var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconChevronUpBlue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2C72DE",
  fillRule: "evenodd",
  d: "m12.471 9.803-.942.943L8 7.218l-3.529 3.528-.942-.943L8 5.332z",
  clipRule: "evenodd"
})));
export { SvgIconChevronUpBlue as ReactComponent };
export default __webpack_public_path__ + "img/icon-chevron-up-blue.04fe6eb8bac3a878339a781f24049d40.svg";